var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyLinkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2457_88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5754 2.30329C12.0502 0.828522 14.0504 0 16.1361 0C20.4792 0 24 3.52081 24 7.86396C24 9.94962 23.1716 11.9498 21.6968 13.4246L18.6213 16.5L16.5 14.3787L19.5754 11.3033C20.4876 10.3911 21 9.15396 21 7.86396C21 5.17767 18.8223 3 16.1361 3C14.846 3 13.6089 3.51244 12.6967 4.42462L9.62131 7.5L7.5 5.37868L10.5754 2.30329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3033 19.5754L14.3787 16.5L16.5 18.6213L13.4246 21.6968C11.9498 23.1716 9.94962 24 7.86396 24C3.52081 24 0 20.4792 0 16.1361C0 14.0504 0.82852 12.0502 2.30329 10.5754L5.37868 7.5L7.5 9.62131L4.42462 12.6967C3.51244 13.6089 3 14.846 3 16.1361C3 18.8223 5.17767 21 7.86396 21C9.15396 21 10.3911 20.4876 11.3033 19.5754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.56078 17.5608L17.5608 8.56078L15.4395 6.43945L6.43945 15.4395L8.56078 17.5608Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2457_88"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLinkIcon);
export default __webpack_public_path__ + "static/media/copy_link_icon.fdb1b68100ac69fcf360e14cf69a582e.svg";
export { ForwardRef as ReactComponent };